import {
  GenericField,
  InputProps,
} from "@/lib/Components/Form/Fields/GenericField";
import { Label } from "@/components/catalyst/fieldset";
import { RadioGroup, RadioField, Radio } from "@/components/catalyst/radio";
import { useField } from "formik";
import { useTranslations } from "use-intl";

export type TrueFalseNullInputProps = InputProps;
export function TrueFalseNullInput({ ...props }: TrueFalseNullInputProps) {
  const [field, , { setValue }] = useField<boolean | null>(props.name);
  const { value } = field;

  const t = useTranslations("common");

  let stringValue;
  switch (true) {
    case value === null || value === undefined:
      stringValue = "NULL";
      break;
    case value === false:
      stringValue = "FALSE";
      break;
    case value === true:
      stringValue = "TRUE";
      break;
    default:
      throw new Error(`Invalid value ${value}`);
  }

  return (
    <GenericField {...props} viewNode={t(`boolean.${value}`)}>
      <RadioGroup
        value={stringValue}
        onChange={(newValStr) => {
          let val;
          switch (newValStr) {
            case "NULL":
              val = null;
              break;
            case "FALSE":
              val = false;
              break;
            case "TRUE":
              val = true;
              break;
            default:
              throw new Error(`Invalid value ${newValStr}`);
          }

          setValue(val);
        }}
      >
        <RadioField>
          <Radio value="NULL" />
          <Label>Unspecified</Label>
        </RadioField>
        <RadioField>
          <Radio value="TRUE" />
          <Label>Yes</Label>
        </RadioField>
        <RadioField>
          <Radio value="FALSE" />
          <Label>No</Label>
        </RadioField>
      </RadioGroup>
    </GenericField>
  );
}
